/**
 * Biome definitions for the wave-based progression system.
 * Biomes cycle every WAVES_PER_BIOME waves: Forest → Cave → Graveyard → Castle → repeat.
 */

export interface Biome {
  id: 'forest' | 'cave' | 'graveyard' | 'castle';
  /** Camera background colour (CSS hex string). */
  bgColor: string;
  /** Ground strip colour (CSS hex string). */
  groundColor: string;
  /** Enemy type ids that can spawn in this biome (from enemies.ts). */
  enemyTypes: string[];
  /** Ambient particle theme. */
  ambientParticles: 'leaf' | 'rock' | 'fog' | 'ember';
  /** Music track identifier (placeholder for audio system). */
  music: string;
}

export const BIOMES: Biome[] = [
  {
    id: 'forest',
    bgColor: '#2d5a27',
    groundColor: '#1e3d1a',
    enemyTypes: ['speeder', 'grunt'],
    ambientParticles: 'leaf',
    music: '',
  },
  {
    id: 'cave',
    bgColor: '#1a1a2e',
    groundColor: '#0f0f1e',
    enemyTypes: ['tank', 'grunt'],
    ambientParticles: 'rock',
    music: '',
  },
  {
    id: 'graveyard',
    bgColor: '#2e1a3e',
    groundColor: '#1e1028',
    enemyTypes: ['ghost', 'speeder'],
    ambientParticles: 'fog',
    music: '',
  },
  {
    id: 'castle',
    bgColor: '#3e1a1a',
    groundColor: '#280f0f',
    enemyTypes: ['grunt', 'speeder', 'tank'],
    ambientParticles: 'ember',
    music: '',
  },
];

/** Number of waves before the biome advances. */
export const WAVES_PER_BIOME = 5;

/** Returns the biome that should be active during the given wave number (1-based). */
export function getBiomeForWave(wave: number): Biome {
  const idx = Math.floor((wave - 1) / WAVES_PER_BIOME) % BIOMES.length;
  return BIOMES[idx];
}
